import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Layout from "../../../components/Layout/Layout";
import { LCTechService } from "../../../services/LCTech/LCTechService";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store";
import LcLoading from "../../../components/Generic/LcLoading";
import { TechEAEASService } from "../../../services/EASubscriptionService/techEAEASService";
import moment from "moment";
import { SaasService } from "../../../services/saas/saasService";
import ImgFluxoEAEAS from "../../../assets/images/Fluxos/eaeas.png";
import ImgFluxoCSP from "../../../assets/images/Fluxos/csp.png";
import { useSnackbar } from "notistack";
import exportFromJSON from "export-from-json";
import PivotTableWebix from "../../../components/webix";
import { PiDownloadLight, PiEyeLight, PiEyeSlashLight, PiInfoLight } from "react-icons/pi";
import { useQuery } from "react-query";
import { UserState } from "../../../store/reducers/userReducer";
import { MenuState } from "../../../store/reducers/menuReducer";

function pivotCheckFilters() {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i) || "";
        const raw = localStorage.getItem(key);
        if (key.match("CSP/LCTechUsage") && raw) {
            return JSON.parse(raw);
        }
    }
}

function sCdateToJsDate(cSDate: string): Date {
    const d = new Date(Date.parse(cSDate));
    return isNaN(d.getTime()) ? new Date() : d;
}

function translateKey(key: string): string {
    const t: Record<string, string> = {
        customerName: "Empresa",
        entitlementName: "Assinatura",
        resourceGroupName: "Grupo do Recurso",
        resourceName: "Recurso",
        meterCategory: "Categoria",
        meterSubCategory: "SubCategoria",
        tag: "Tags",
        unitOfMeasure: "Unidade",
        currencyCode: "Moeda",
        meterName: "Nome do Medidor",
        year: "Ano Consumo",
        month: "Mês Consumo",
        day: "Dia Consumo",
        quantityUsed: "Quantidade",
        totalCost: "Total",
    };
    return t[key] || key;
}

const LCTechUsage: React.FC = props => {
    const service = new LCTechService(props);
    const history = useHistory();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const menu = useSelector<RootState, MenuState>(s => s.menu);
    const user = useSelector<RootState, UserState>(s => s.user);
    const path = document.location.pathname;
    const sel = user.PeriodSelection?.[path];

    const [consumoToUpper, setConsumoToUpper] = useState(true);
    const [showEAEAS, setShowEAEAS] = useState(false);
    const [showCSP, setShowCSP] = useState(false);
    const [footer, setFooter] = useState("-");
    const [records, setRecords] = useState<any[]>([]);

    // calcula data inicial ajustando também o sel quando for do mês atual
    const getInitialDate = (): Date => {
        const today = new Date();

        if (sel) {
            const selDate = new Date(sel.fields[0].value);
            const isSameMonth =
                selDate.getFullYear() === today.getFullYear() &&
                selDate.getMonth() === today.getMonth();
 
            return selDate;
        }

        // sem sel
        if (today.getDate() <= 5) {
            today.setDate(today.getDate() - 5);
        }
        return today;
    };

    const initialDate = getInitialDate();

    const [day, setDay] = useState(initialDate.getDate().toString());
    const [month, setMonth] = useState((initialDate.getMonth() + 1).toString());
    const [year, setYear] = useState(initialDate.getFullYear().toString());

    const opts = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };

    const fetchUsage = async () => {
        const resp = await service.RetrieveUsage(1, consumoToUpper, month, year);
        return resp.data;
    };

    function getPreviousDays(d: number, m: number, y: number, back: number) {
        const out: { day: number; month: number; year: number }[] = [];
        let cur = new Date(y, m - 1, d);
        for (let i = 0; i < back; i++) {
            cur.setDate(cur.getDate() - 1);
            out.push({ day: cur.getDate(), month: cur.getMonth() + 1, year: cur.getFullYear() });
        }
        return out;
    }

    const { isLoading, isFetching } = useQuery(
        ["usage", month, year, consumoToUpper],
        fetchUsage,
        {
            // Nunca trate os dados como “frescos”
            staleTime: 0,
            // Descarte o cache imediatamente após a query sair de uso
            cacheTime: 0,
            // Refaça a query sempre que o componente montar
            refetchOnMount: "always",
            // Desabilita refetch automático ao focar na janela
            refetchOnWindowFocus: false,
            retry: 4,
            onSuccess: data => {
                if (!data.resourceUsageRecords?.length) return setFooter("");
                const today = new Date();
                const d2 = new Date(today);
                d2.setDate(today.getDate() - 1);

                const pivot = data.resourceUsageRecords.map(r => ({
                    ...r,
                    month: sCdateToJsDate(r.usageDate).getMonth() + 1,
                    day: sCdateToJsDate(r.usageDate).getDate(),
                    year: sCdateToJsDate(r.usageDate).getFullYear(),
                    quantityUsed: parseInt(r.quantityUsed, 10),
                }));

                let filtered = pivot;
                if (today.getDate() <= 2) {
                    const days = getPreviousDays(
                        today.getDate() === 1 ? d2.getDate() : d2.getDate() - 1,
                        d2.getMonth() + 1,
                        d2.getFullYear(),
                        90
                    );
                    filtered = pivot.filter(r =>
                        days.some(d => d.day === r.day && d.month === r.month && d.year === r.year)
                    );
                }

                filtered.sort((a, b) =>
                    new Date(a.year, a.month - 1, a.day).getTime() -
                    new Date(b.year, b.month - 1, b.day).getTime()
                );
                setRecords(filtered);

                const lm = new Date(data.lastModifiedDate);
                const first = new Date(lm.getFullYear(), lm.getMonth(), 1);
                setFooter(
                    `Período de apuração: ${first.toLocaleDateString("pt-BR")} a ${lm.toLocaleDateString("pt-BR")}. ` +
                    `Valores estimados, sujeitos a validação e políticas de contabilização do vendor. Sync ${lm.toLocaleDateString("pt-BR")}`
                );
            },
            onError: console.error,
        }
    );

    const periodSelection = {
        periods: [
            { label: "Este mês", text: "Este mês", fields: [{ name: "month", value: moment().format("YYYY-MM") }], default: true },
            { label: "Mês anterior", text: "Mês anterior", fields: [{ name: "month", value: moment().add(-1, "M").format("YYYY-MM") }] },
        ],
        customPeriod: { label: "Personalizado", text: "personalizado", fields: [{ name: "month", label: "Mês", value: "" }] },
        customPeriodType: "month",
        onChange: sel => {
            const [y, m] = sel.fields[0].value.split("-");
            setYear(y);
            setMonth(m);
        },
    };

    useEffect(() => {
        if (menu.selectedItem?.id === "cedcb443-a23e-4545-904b-5d1061e718aa") {
            new TechEAEASService({})
                .GetSaasLicenseByCountryTotalView()
                .then(r => setShowEAEAS(r.data.length === 0))
                .catch(() => setShowEAEAS(true));
        }
    }, [menu]);

    useEffect(() => {
        if (menu.selectedItem?.id === "67aa56e4-ad63-44b0-aa27-d2d2a8665a63") {
            new SaasService({})
                .GetbyClientGroupIdAndTileId("13")
                .then(r => setShowCSP(!r.data))
                .catch(console.warn);
        }
    }, [menu]);

    const exportToCSV = () => {
        enqueueSnackbar("Gerando arquivo", { variant: "info", preventDuplicate: true });
        const filters = pivotCheckFilters()!;
        const data = records.map(r => {
            const item: Record<string, any> = {};
            filters.rows.forEach((row: string) => row in r && (item[translateKey(row)] = r[row]));
            filters.columns.forEach((col: string) => col in r && (item[translateKey(col)] = r[col]));
            filters.values.forEach((v: any) => v.name in r && (item[translateKey(v.name)] = r[v.name]));
            return item;
        });
        exportFromJSON({
            data,
            fields: [...filters.rows, ...filters.columns, ...filters.values.map((v: any) => v.name)].map(translateKey),
            fileName: "LCTechCSPUsage",
            exportType: "csv",
            withBOM: true,
            delimiter: ";",
        });
        enqueueSnackbar("Arquivo gerado com sucesso", { variant: "success", preventDuplicate: true });
    };

    return (
        <Layout
            periodSelection={periodSelection}
            pageTitle={service.title}
            pivot
            functionsGeneric={[
                {
                    icon: <PiInfoLight />,
                    tooltip: () =>
                        footer && (
                            <div style={{ width: "90%", height: 25, borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <span style={{ fontSize: 8 }}>{footer}</span>
                            </div>
                        ),
                    onClick: () => null,
                },
                { icon: <PiDownloadLight />, onClick: exportToCSV, tooltip: "Exportar para .csv" },
                {
                    icon: consumoToUpper ? <PiEyeLight /> : <PiEyeSlashLight />,
                    onClick: () => setConsumoToUpper(!consumoToUpper),
                    tooltip: consumoToUpper ? "Visualizar padrão Microsoft" : "Não visualizar padrão Microsoft",
                },
            ]}
        >
            <LcLoading loading={isLoading || isFetching}>
                {showEAEAS ? (
                    <div className="lc-segment" style={{ width: "100%" }}>
                        <div className="body" style={{ width: "100%" }}>
                            Para o funcionamento completo da solução é necessário que todos os passos do fluxo abaixo estejam corretamente executados. Caso precise de ajuda abra uma requisição clicando{" "}
                            <span className="link text-link" onClick={() => { history.push("/Chamados"); dispatch({ type: "MENU_NEW_REQUEST", payload: true }); }}>
                                aqui
                            </span>
                            <img src={ImgFluxoEAEAS} width="100%" alt="Procedimento" />
                        </div>
                    </div>
                ) : showCSP ? (
                    <div className="lc-segment">
                        <div className="body">
                            Para o funcionamento completo da solução é necessário que todos os passos do fluxo abaixo estejam corretamente executados. Caso precise de ajuda abra uma requisição clicando{" "}
                            <span className="link text-link" onClick={() => { history.push("/Chamados"); dispatch({ type: "MENU_NEW_REQUEST", payload: true }); }}>
                                aqui
                            </span>
                            <img src={ImgFluxoCSP} width="100%" alt="Procedimento" />
                        </div>
                    </div>
                ) : (
                    <div style={{ minWidth: "100%" }}>
                        {records.length > 0 && (
                            <PivotTableWebix
                                style={{ minWidth: "100%" }}
                                idView={month}
                                key={month}
                                data={records}
                                fields={[
                                    { id: "customerName", value: "Empresa", type: "text" },
                                    { id: "entitlementName", value: "Assinatura", type: "text" },
                                    { id: "resourceGroupName", value: "Grupo do Recurso", type: "text" },
                                    { id: "resourceName", value: "Recurso", type: "text" },
                                    { id: "meterCategory", value: "Categoria", type: "text" },
                                    { id: "meterSubCategory", value: "SubCategoria", type: "text" },
                                    { id: "tag", value: "Tags", type: "text" },
                                    { id: "unitOfMeasure", value: "Unidade", type: "text" },
                                    { id: "currencyCode", value: "Moeda", type: "text" },
                                    { id: "meterName", value: "Nome do Medidor", type: "text" },
                                    { id: "year", value: "Ano", type: "text" },
                                    { id: "month", value: "Mês", type: "text" },
                                    { id: "day", value: "Dia", type: "number" },
                                    { id: "quantityUsed", value: "Quantidade", type: "number" },
                                    { id: "totalCost", value: "Total", type: "number" },
                                ]}
                                structure={{
                                    rows: ["customerName", "entitlementName", "resourceGroupName", "currencyCode"],
                                    columns: ["year", "month"],
                                    values: [{ name: "totalCost", operation: ["sum"] }],
                                }}
                            />
                        )}
                    </div>
                )}
            </LcLoading>
        </Layout>
    );
};

export default LCTechUsage;
